import React, { FC, useState } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import ManageFileTypes from '../manage-file-types';
import UserAccessManagement from '../user-access-management';
import UserAccessList from '../user-access-list';
import ManageDeviceTypes from '../manage-device-types';
import ManualOnboarding from '../manual-onboarding';
import VIMSSFTPConfig from '../vimsSFTP-accordion';
import MessageReplay from '../message-replay';
import useStyles from './styles';
import { deployUpTo, EnvironmentNames } from '../../../utilities';
import BulkFileTypeConfiguration from '../bulk-file-type-configuration';
import { AppState } from '../../../store';


type AccordionItem = { title: string; open: boolean; component: FC<{}> };
type AccordionData = { title: string; data: AccordionItem[] }[];


const AdminAccordion = () => {
  const classes = useStyles();
  const appPermissions = useSelector(
    (state: AppState) => state.entitlements?.authorizations?.appPermissions,
  );
  const adminModules = appPermissions?.iot?.Administration ?? [];
  const showRoleManagement = adminModules.includes('roleManagement');
  const showUserManagement = adminModules.includes('userManagement');
  const showDeviceOnboarding = adminModules.includes('deviceOnboarding');
  const showMessageReply = adminModules.includes('messageReplay');
  const showFileTypeConfig = adminModules.includes('fileTypeConfiguration');
  const showBulkFileTypeConfig = adminModules.includes('bulkFileTypeConfiguration');

  const data: ({ title: string; open: boolean; component: any })[] = [];

  if (showRoleManagement) {
    data.push({ title: 'User Access Management', open: true, component: UserAccessManagement });
  }
  if (showRoleManagement) {
    data.push({ title: 'User List', open: false, component: UserAccessList });
  }

  if (showFileTypeConfig) {
    data.push({ title: 'File Type Configuration', open: false, component: ManageFileTypes });
  }

  if (showBulkFileTypeConfig) {
    data.push({
      title: 'Bulk File Type Configuration',
      open: false,
      component: BulkFileTypeConfiguration,
    });
  }

  if (showUserManagement) {
    data.push({ title: 'Device Type Configuraiton', open: false, component: ManageDeviceTypes });
  }

  if (showRoleManagement) {
    data.push({ title: 'VIMS SFTP User Config', open: false, component: VIMSSFTPConfig });
  }

  if (showDeviceOnboarding) {
    data.push({ title: 'Manual Onboarding', open: false, component: ManualOnboarding });
  }

  if (showMessageReply) {
    data.push({ title: 'Message Replay', open: false, component: MessageReplay });
  }
  const sections = [
    {
      title: '',
      data,
    },
  ];
  // if (!deployUpTo(EnvironmentNames.integration)) {
  //   delete sections[0].data[3];
  // }
  const [accordionData, setAccordionData] = useState<AccordionData>(sections);
  const toggleOpen = (sectionIterator: number, componentIterator: number) => {
    const toggledAdminAccordion = [...accordionData];
    toggledAdminAccordion[sectionIterator].data[componentIterator].open = !accordionData[sectionIterator]
      .data[componentIterator].open;
    setAccordionData(toggledAdminAccordion);
  };
  return (
    <div className={classes.accordions}>
      {accordionData.map((section, sectionIterator) => (
        <>
          <Box>
            <Typography variant="h6">{section.title}</Typography>
          </Box>
          {section.data.map((componentContainer, componentIterator) => (
            <Accordion
              id={`${componentContainer.title}Panel`}
              expanded={componentContainer.open}
              onChange={() => toggleOpen(sectionIterator, componentIterator)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h5">{componentContainer.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {componentContainer.open && <componentContainer.component />}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ))}
    </div>
  );
};

export default AdminAccordion;
